import { isFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * CLOUD-4582: Фича для отображения лендинга с новой подпиской
 */
export const familyRebornLanding = isFeature('family-reborn-landing');

/**
 * CLOUD-4667: Фичи для эксперимента по улучшению конверсии
 */
export const familyLandingCtaScroll = isFeature('family-landing-cta-scroll');
export const familyLandingCtaTariffOverride = isFeature('family-landing-cta-tariff-override');
